
import { useStore } from "vuex";
import { defineComponent } from "vue";
import GenericButton from "../shared/GenericButton.vue";

export default defineComponent({
  name: "SupportPerks",
  components: {
    GenericButton,
  },
  setup() {
    const store = useStore();
    const getButtonClass = (category: string, perk: string) => {
      const perkData = store.state.build[category][perk];
      if (perkData.tagged) {
        return "perk-button perk-tagged";
      } else if (perkData.available) {
        return "perk-button perk-available item-hover";
      } else {
        return "perk-button perk-not-available";
      }
    };
    const tagPerk = (category: string, perk: string): void => {
      store.dispatch("handleIncomingCommand", {
        command: "tagPerk",
        data: { category, perk },
      });
    };
    const showInfo = (category: string, stat: string) => {
      store.dispatch("handleIncomingCommand", {
        command: "updateInfoPanel",
        data: { category, stat },
      });
    };
    const getPerkButtonName = (category: string, perk: string) => {
      return `${store.state.build[category][perk].name} ${
        store.state.build[category][perk].taggedAt
          ? `(${store.state.build[category][perk].taggedAt})`
          : ""
      }`;
    };
    return {
      state: store.state,
      getButtonClass,
      getPerkButtonName,
      tagPerk,
      showInfo,
    };
  },
});
